import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'payoutCode',
		pluralName: 'payoutCodes',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
